{
  "en": {
    "customer": {
      "storefront": {
        "loading_error": {
          "description": "Sorry — we're having an issue loading this store. Check your internet and try again, or otherwise contact our customer service team for help.",
          "title": "We couldn't load this store"
        },
        "product_modal": {
          "meal_preferences_label": "Meal preferences",
          "meal_preferences_placeholder": "E.g. ‘Easy on the salt’ or ‘No gherkins’"
        },
        "fulfillment_method": {
          "not_supported": {
            "customer_pickup": {
              "title": "This store doesn't offer pickup",
              "description": "View items for delivery or browse other places with in-store pickup"
            }
          }
        }
      }
    }
  }
}
